import axios from 'axios';
import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { API_URL } from '../../config/URL/URL';

const { persistAtom } = recoilPersist({
    key: 'logTokenStorage',
    storage: sessionStorage,
});

export const logTokenAtom = atom({
    key: 'logToken',
    default: null,
    effects_UNSTABLE: [persistAtom],
});

/**
 * 서버에서 방문 토큰을 가져오는 함수
 * @returns {Promise<string|null>} Bearer 토큰 또는 null
 */
export const getToken = async () => {
    try {
        const response = await axios.get(`${API_URL}/log/visit`);
        const token = `Bearer ${response.data}`;
        return token;
    } catch (error) {
        console.error('토큰 가져오기 중 오류 발생:', error);
        return null;
    }
};
